"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var BaseCollectionPaginationWrapper = /** @class */ (function (_super) {
    __extends(BaseCollectionPaginationWrapper, _super);
    function BaseCollectionPaginationWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseCollectionPaginationWrapper.prototype.findCurrentPage = function () {
        return this.find(".awsui-" + this.name + "-pagination-current-page");
    };
    BaseCollectionPaginationWrapper.prototype.findPageNumbers = function () {
        return this.findAll(".awsui-" + this.name + "-pagination-page-number");
    };
    /**
     * Returns a page number for a given index.
     *
     * @param index 1-based index of the page number to return.
     */
    BaseCollectionPaginationWrapper.prototype.findPageNumberByIndex = function (index) {
        // we need to skip the "previous page" button
        var pageIndex = index + 1;
        return this.find(".awsui-" + this.name + "-pagination-page-number:nth-child(" + pageIndex + ") button");
    };
    BaseCollectionPaginationWrapper.prototype.findPreviousPageButton = function () {
        return this.find(".awsui-" + this.name + "-pagination-prev-page button");
    };
    BaseCollectionPaginationWrapper.prototype.findNextPageButton = function () {
        return this.find(".awsui-" + this.name + "-pagination-next-page button");
    };
    return BaseCollectionPaginationWrapper;
}(dom_1.ComponentWrapper));
exports.BaseCollectionPaginationWrapper = BaseCollectionPaginationWrapper;
var TablePaginationWrapper = /** @class */ (function (_super) {
    __extends(TablePaginationWrapper, _super);
    function TablePaginationWrapper(element) {
        var _this = _super.call(this, element) || this;
        _this.name = 'table';
        return _this;
    }
    return TablePaginationWrapper;
}(BaseCollectionPaginationWrapper));
exports.default = TablePaginationWrapper;
//# sourceMappingURL=awsui-table-pagination.js.map